import { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { usePreferences } from '../../contexts/PreferencesContext';
import UiPropsModal from '../UiPropsModal/UiPropsModal';
import styles from './OptionsModal.module.css';

const OptionsModal = ({ onClose }) => {
  const { logout } = useAuth();
  const {  preferences,  savePreferences,  resetToDefault} = usePreferences();

  const [tempAccent, setTempAccent] = useState(preferences.accentColor);
  const [tempFontSize, setTempFontSize] = useState(preferences.fontSize);
  const [showUiPropsModal, setShowUiPropsModal] = useState(false);

  const DEFAULT_PREFS = { accentColor: '#6366f1', fontSize: 100 };

  // Hilfsfunktion, die die CSS-Variablen sofort setzt
  /* const applyCssVariables = (accent, fontSize) => {
    document.body.style.setProperty('--user-accent', accent);
    document.body.style.setProperty('--user-accent-light', accent);
    document.body.style.setProperty('--user-accent-dark', accent);
    const baseSize = (fontSize / 100) * 16;
    document.body.style.setProperty('--base-font-size', `${baseSize}px`);
  }; */

  const handleSave = async () => {

    await savePreferences({
      ...preferences,
      accentColor: tempAccent,
      fontSize: tempFontSize
    });

    onClose();
  };

  const handleReset = async () => {
    setTempAccent('#6366f1');
    setTempFontSize(100);

    await resetToDefault();
  };

  return (
    <>
      <div className={styles.overlay} onClick={onClose}>
        <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
          <h3>Einstellungen</h3>

          <div className={styles.settingGroup}>
            <label>Akzentfarbe</label>
            <input
              type="color"
              value={tempAccent}
              onChange={(e) => setTempAccent(e.target.value)}
              className={styles.colorPicker}
            />
          </div>

          <div className={styles.settingGroup}>
            <label>Schriftgröße: {tempFontSize}%</label>
            <input
              type="range"
              min="80"
              max="140"
              step="5"
              value={tempFontSize}
              onChange={(e) => setTempFontSize(parseInt(e.target.value, 10))}
              className={styles.slider}
            />
          </div>

          <div className={styles.buttonGroup}>
            <button className={styles.resetBtn} onClick={handleReset}>
              Auf Standard zurücksetzen
            </button>
          </div>

          <hr className={styles.divider} />

          <button className={styles.option}>Profil bearbeiten</button>
          <button 
            className={styles.option} 
            onClick={() => setShowUiPropsModal(true)}
          >
            Weitere Einstellungen
          </button>
          <button className={styles.saveBtn} onClick={handleSave}>
            Übernehmen
          </button>

          <button className={styles.logout} onClick={logout}>
            Abmelden
          </button>
        </div>
      </div>

      {showUiPropsModal && (
        <UiPropsModal onClose={() => setShowUiPropsModal(false)} />
      )}
    </>
  );
};

export default OptionsModal;